import { render } from "./AppContact.vue?vue&type=template&id=888bb654"
import script from "./AppContact.vue?vue&type=script&lang=js"
export * from "./AppContact.vue?vue&type=script&lang=js"

import "./AppContact.vue?vue&type=style&index=0&id=888bb654&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__